<template>
    <q-page class="q-pa-md">

        <q-dialog v-model="dialogConfirmacion" persistent>
            <q-card v-if="archivoSeleccionado != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Estas seguro de enviar el comprobante de pago
                                <strong>{{ archivoSeleccionado.name }}</strong>.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al cargar el comprobante de pago, pasara la cuenta automaticamente a pagado.
                        </p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="UpdateCxc()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogComprobante" persistent>
            <q-card style="width: 600px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Comprobante de Pago</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-card class="shadow-0" v-if="selectCuenta != null">
                        <q-card-section class="row items-center q-col-gutter-md q-pb-none">
                            <div class="col-12 col-md-12">
                                <q-file v-model="archivoSeleccionado" dense outlined label="Subir Comprobante de Pago"
                                    class="full-width">
                                </q-file>
                            </div>
                            <div class="col-12 col-md-12">
                                <q-input class="q-pb-none" dense outlined v-model="fechadepago"
                                    label="Fecha en la que se realizo el Pago" mask="date" bottom-slots
                                    placeholder="yyyy/MM/dd">
                                    <template v-slot:after>
                                        <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                            <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy"
                                                transition-show="scale" transition-hide="scale">
                                                <q-date class="q-ma-none q-pa-none" v-model="fechadepago">
                                                    <div class="row items-center justify-end q-ma-none q-pa-none">
                                                        <q-btn v-close-popup label="Ok" color="primary"
                                                            class="q-ma-none q-pa-none" flat />
                                                    </div>
                                                </q-date>
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-card-section>
                <q-card-section>
                    <div class="row">
                        <q-btn flat color="red" label="CERRAR" class="q-ml-sm" v-close-popup />
                        <q-space />
                        <q-btn flat class="q-ml-sm" color="primary" label="Guardar Comprobante"
                            @click="dialogConfirmacion = true" />
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Nueva Cuenta por Pagar</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">
                    <div class="col-12">
                        <q-select outlined v-model="selectCliente" :options="clientes" label="Nombre del Cliente"
                            option-label="rfc" dense required emit-value map-options
                            @input="GetVehiculosPorClienteAsync">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-account" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' ' + scope.opt.razon_social" />
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12">
                        <q-select outlined v-model="selectAuto" :options="autosCliente" label="Vehículo"
                            option-label="texto" option-value="id" dense emit-value map-options>
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>{{ scope.opt.marca }} {{ scope.opt.modelo }} ({{ scope.opt.anio
                                        }})</q-item-label>
                                        <q-item-label caption>Placa: {{ scope.opt.placa }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12">
                        <q-select outlined v-model="selectTipoPago" :options="tiposDePagos" label="Tipo de Pago" dense
                            emit-value map-options @input="GetProveedores"></q-select>
                    </div>
                    <div class="col-12 col-md-12">
                        <q-select dense outlined v-model="selectAgencia" :options="listaAgencias" label="Proveedor"
                            color="primary" option-label="razon_social" clearable
                            options-selected-class="text-deep-blue">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                        <q-item-label caption>{{ scope.opt.representante
                                            }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12 col-md-12">
                        <q-input dense v-model="concepto" outlined label="Concepto" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input prefix="$" dense v-model="monto" outlined label="Monto a Pagar" required mask="#.##"
                            fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input prefix="$" dense v-model="comision" outlined label="Comision" required mask="#.##"
                            fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input class="q-pb-none" dense outlined v-model="fechamaximapago"
                            label="Fecha de Maxima de Pago" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechamaximapago">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12">
                        <q-select outlined dense v-model="modelCrearCuenta" :options="['Si', 'No']"
                            label="Crear cuenta por cobrar en automatico" />
                    </div>
                    <!-- <div class="col-12 q-ml-sm doc-note">
                        <p class="doc-note__title">Aviso</p>
                        <p class=""> Al crear la cuenta por pagar, asi mismo se le creara una cuanta por cobrar al
                            cliente.</p>
                    </div> -->
                </q-card-section>

                <q-card-actions class="row justify-between">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn @click="PostCuentaPagar()" flat color="primary" label="Crear Cuenta" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md" style="height: 100%; overflow-y: auto;">
            <div class="col-12">
                <q-table dense title="Cuentas Por Pagar" class="shadow-1" :data="dataList" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-select outlined v-model="estadoCuenta" :options="itemsCuentasEstados" label="Estado"
                            class="q-my-md q-mr-md" option-label="label" option-value="value" dense required emit-value
                            map-options style="width: 200px;" />
                        <q-select outlined v-model="selectTipoPago" :options="tiposDePagos" label="Tipo de Pago"
                            class="q-my-md" dense required emit-value map-options style="width: 150px;" />
                        <q-btn outline color="primary" icon="mdi-plus" label="Nueva cuenta" no-caps
                            class="q-ml-sm q-my-md" @click="nuevaCuenta()" />
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetCxP()" no-caps
                            class="q-ml-sm q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre }}</q-td>
                            <q-td key="concepto" :props="props" @click="verItem(props.row)">{{ props.row.concepto
                            }}</q-td>
                            <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                            <q-td key="tipo" :props="props" @click="verItem(props.row)">{{ props.row.tipo ?
                                props.row.tipo.toUpperCase() : ''
                                }}</q-td>
                            <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechacreacion) }}</q-td>
                            <q-td key="fechamaximapago" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechamaximapago) }}</q-td>
                            <q-td key="estado" :props="props">
                                <q-badge v-if="props.row.estado == 'XP'" color="orange" label="Cuenta por Pagar" />
                                <q-badge v-if="props.row.estado == 'V'" color="purple" label="Pendiente de Validar" />
                                <q-badge v-if="props.row.estado == 'P'" color="green" label="Pagado" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VistasPreviasPDF.vue";
import moment from 'moment';
export default {
    components: {
        VisualizadorPDF
    },
    data() {
        return {
            selectCliente: null, selectAuto: null,
            autosCliente: [],
            clientes: [],
            tiposDePagos: ['Seguro', 'Multas', 'Tenencia', 'Verificación', 'Corralón', 'Grua', 'OtrasSanciones'],
            selectTipoPago: '',
            loading: false,
            dataList: [],
            columns: [
                { name: 'nombre', label: 'Proveedor', field: 'nombre', align: 'center', sortable: true },
                { name: 'concepto', label: 'Concepto', field: 'concepto', align: 'center', sortable: true },
                { name: 'monto', label: 'Monto', field: 'monto', align: 'right', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'fechacreacion', label: 'Fecha', field: 'fechacreacion', align: 'center', sortable: true },
                { name: 'fechamaximapago', label: 'Fecha Maxima De Pago', field: 'fechamaximapago', align: 'center', sortable: true },
                { name: 'estado', label: 'Estatus', field: 'estado', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            estadoCuenta: '',
            itemsCuentasEstados: [
                { value: 'XP', label: 'Cuentas por Pagar' },
                { value: 'P', label: 'Pagado' }
            ],
            dialogDetalles: false,
            cuenta: {
                cxc: {
                    id_documento: '',
                    id_cliente: '',
                    nombre: '',
                    concepto: '',
                    monto: 0,
                    tipo: '',
                    procedencia: ''
                },
                cxp: {
                    id_proveedor: '',
                    nombre: '',
                    tipo: '',
                    monto: 0,
                    comision: 0,
                    id_vehiculo: '',
                    fechamaximapago: ''
                },
            },
            monto: 0,
            comision: 0,
            fechamaximapago: '',
            concepto: '',
            listaAgencias: [],
            selectAgencia: null,
            selectCuenta: null,
            dialogConfirmacion: false,
            fechadepago: '',
            archivoSeleccionado: null,
            dialogComprobante: false,
            modelCrearCuenta: 'Si'

        }
    },
    async mounted() {
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
        this.GetClientes();
    },
    methods: {
        async UpdateCxc() {
            const archivo = this.archivoSeleccionado;

            if (!archivo) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Debes seleccionar un archivo primero.',
                    position: 'top-right'
                });
                return;
            }

            const base64 = await this.convertirABase64(archivo);
            let nombre_archivo = archivo.name;
            let archivo64base = base64;

            let objeto = {
                id: this.selectCuenta._id,
                imagen: archivo64base,
                nombre: nombre_archivo,
                fecha: this.fechadepago
            }
            console.log(objeto)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Subiendo comprobante de pago. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('CXC/ActualizaCxp', objeto)
                console.log(respuesa)
                this.$q.loading.hide()

                this.selectCuenta.estado = 'P'
                const index = this.dataList.findIndex(p => p._id === this.selectCuenta._id)
                this.$set(this.dataList, index, { ...this.selectCuenta })

                this.dialogConfirmacion = false
                this.dialogComprobante = false
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se envio el comprobante, debera esperar a que sea validado.` });
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al enviar el comprobante, intentelo de nuevo.` });
                console.log(error)
            }

        },
        async verItem(item) {

            if (item.estado == 'P') {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Su pago fue realizado correctamente...', messageColor: 'white' })
                this.timer = setTimeout(() => {
                    this.$q.loading.hide()
                    this.timer = void 0
                }, 3000)
                return
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            this.selectCuenta = item
            this.dialogComprobante = true
            this.$q.loading.hide()
        },
        async GetClientes() {
            try {
                let respuesa = await axios.get('Configuracion/GetUsuariosDatosFiscales/')
                // let respuesa = await axios.get('Login/GetClientes/')
                console.log(respuesa)
                this.clientes = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async GetVehiculosPorClienteAsync() {
            if (!this.selectCliente) return;

            try {
                const res = await axios.get(`Autos/GetVehiculosPorClienteAsync/${this.selectCliente._id_cliente}`);
                // Puedes agregar campo "texto" al vuelo si quieres usarlo en option-label (opcional)
                console.log(res)
                this.autosCliente = res.data.map(auto => ({
                    ...auto,
                    texto: `${auto.marca} ${auto.modelo} (${auto.anio}) - ${auto.placa}`
                }));
            } catch (err) {
                console.error('Error al obtener autos:', err);
                this.autosCliente = [];
            }
        },

        async PostCuentaPagar() {
            if (this.selectCliente == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el cliente al que se le haran los cargos.` });
                return
            }
            if (this.selectAuto == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el vehiculo del cliente.` });
                return
            }
            if (this.selectTipoPago == "") {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el tipo de pago que se realizara.` });
                return
            }
            if (this.selectAgencia == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el proveedor al que se realizara el pago.` });
                return
            }
            if (this.concepto == "") {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el concepto de pago.` });
                return
            }
            if (this.monto == 0) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `El monto a pagar debe ser mayo a $0.00.` });
                return
            }
            if (this.fecha == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique una mecha maxima para realizar el pago.` });
                return
            }
            try {
                let cxc = {
                    id_documento: this.selectAuto,
                    id_cliente: this.selectCliente._id_cliente,
                    nombre: this.selectCliente.rfc + " " + this.selectCliente.razon_social,
                    concepto: this.concepto,
                    monto: this.monto,
                    tipo: this.selectTipoPago,
                    procedencia: 'Vehiculo'
                }

                let cxp = {
                    id_proveedor: this.selectAgencia._id,
                    nombre: this.selectAgencia.razon_social,
                    tipo: this.selectTipoPago,
                    monto: this.monto,
                    comision: this.comision,
                    id_vehiculo: this.selectAuto,
                    fechamaximapago: this.fechamaximapago
                }

                let objeto = {
                    Dcxc: this.modelCrearCuenta.toLowerCase(),
                    cxc: cxc,
                    cxp: cxp
                }
                console.log(objeto)
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Generando cuenta por pagar. Espere...', messageColor: 'white' })

                const resp = await axios.post(`CXC/PostCxCModulo/`, objeto);
                console.log(resp)

                if (respuesa.data.edopet == '1') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo y se envio la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `La cuenta por cobrar se ha facturado correctamente.` });
                }
                if (respuesa.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo y se envio la cuenta por cobrar correctamente.` });
                    this.$q.notify({ type: 'negative', position: 'top-right', message: respuesa.edopet.mensaje });
                }
                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al regitrat la cuenta. Intentelo de nuevo...` });
                console.log(error)
            }
        },
        async GetProveedores() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/' + this.selectTipoPago)
                console.log(respuesa.data)
                this.listaAgencias = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetCxP() {
            this.loading = true
            try {
                let respuesa = await axios.get('CXC/GetCxpEstadoTipo/' + this.estadoCuenta + '/' + this.selectTipoPago)
                console.log(respuesa)
                this.loading = false

                this.dataList = respuesa.data.lista
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        nuevaCuenta() {
            this.dialogDetalles = true
        },
        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },

    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>